import * as FXTracker from 'fx-tracker-web';
import { HOST, LOCAL_STORAGE, LOCAL_STORAGE_MIGRATE } from '~/constants';
import { get, getUUID, isPlainObject } from '@libs/shared';
import { localStorageManager } from '~/utils';
import siteRouterManager from '~/utils/site-router';

export type tExt = string | IExtObj;

export interface IExtObj {
    [key: string]: string | number;
}

/**
 * 埋点配置
 *
 * @param user
 * @param user.username
 * @param user.corp_id
 * @param user.is_owner
 * @param user.is_admin
 * @param user.is_platform_manager
 * @param user.is_external_user 是否为外部用户
 * @param user.vip_level
 * @param user.user_id
 * @param user.member_id
 */
export const setTrackerConfig = (user: {
    username: string;
    user_id: string;
    /**
     * 为了保持兼容，埋点参数里选择把corp_id和tenant_id一起传，后续可能会考虑把这个参数删掉，只保留tenant_id
     * @see https://project.feishu.cn/b2rl2h/assignment/detail/5985179746
     * @deprecated
     */
    corp_id: string;
    tenant_id: string;
    member_id: string;
    is_owner?: boolean;
    is_admin?: boolean;
    is_platform_manager?: boolean;
    is_external_user?: boolean;
    vip_level?: string;
}) => {
    FXTracker.config({
        host: HOST.TRACK_HOST,
        defaultParam: {
            user,
            project: 'fx-corp-web',
            hostname: siteRouterManager.getHostSiteWithBasePath(),
            token: get(window.jdy_config, 'track_log_token', '')
        }
    });
};

/**
 * 触发埋点
 *
 * @param evt
 * @param ext
 */
export const tracker = (evt: string | Record<string, any>, ext?: tExt, entity: IExtObj = {}) => {
    if (!evt || window.jdy_config.track_enable === false) {
        return;
    }
    if (!FXTracker.configured()) {
        const getUserCookieId = () => {
            return localStorageManager.getItemWithMigrate({
                oldKey: LOCAL_STORAGE.USER_COOKIE_ID,
                newKey: LOCAL_STORAGE_MIGRATE.USER_COOKIE_ID
            });
        };
        if (!getUserCookieId()) {
            localStorageManager.set(LOCAL_STORAGE_MIGRATE.USER_COOKIE_ID, getUUID());
        }
        setTrackerConfig({
            username: getUserCookieId(),
            corp_id: '',
            tenant_id: '',
            user_id: getUserCookieId(),
            member_id: ''
        });
    }
    const custom_params: IExtObj = {};
    if (ext) {
        if (isPlainObject(ext)) {
            Object.keys(ext)
                .slice(0, 5)
                .forEach((key, index) => {
                    custom_params[`p${index + 1}`] = get(ext, key);
                });
        } else {
            custom_params['p1'] = ext as string;
        }
    }
    FXTracker.dt(evt, {
        custom_params,
        entity
    });
};
